import React, { useEffect } from "react";
import ReactModal from "react-modal";

type ModalProps = {
  isOpen: boolean;
  onRequestClose?: () => void;
  children: React.ReactNode;
  ariaHideApp?: boolean;
  appElement?: HTMLElement | undefined;
  shouldCloseOnOverlayClick?: boolean;
  shouldCloseOnEsc?: boolean;
  className?: string;
  overlayClassName?: string;
  style?: {
    overlay?: React.CSSProperties;
  };
};

export const RegularModal = ({
  isOpen,
  children,
  className,
  overlayClassName,
}: ModalProps) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  return (
    <BaseModal
      isOpen={isOpen}
      className={`fixed inset-0 flex items-center justify-center ${className}`}
      overlayClassName={`fixed inset-0 bg-black ${overlayClassName} z-50`}
    >
      {children}
    </BaseModal>
  );
};

export const BottomModal = ({
  isOpen,
  children,
  className,
  overlayClassName,
}: ModalProps) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  return (
    <BaseModal
      isOpen={isOpen}
      className={`fixed inset-0 flex items-end sm:items-center justify-center ${className}`}
      overlayClassName={`fixed inset-0 bg-black ${overlayClassName} z-50`}
    >
      {children}
    </BaseModal>
  );
};

export const DrawerModal = ({
  isOpen,
  children,
  className,
  overlayClassName,
  style = {
    overlay: {
      zIndex: 1000,
    },
  },
  onRequestClose,
}: ModalProps) => {
  return (
    <BaseModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      shouldCloseOnOverlayClick={true}
      className={`fixed top-0 right-0 bottom-0 sm:w-[400px] bg-white shadow-md focus:outline-none flex flex-col w-full ${className}`}
      overlayClassName={`fixed top-0 left-0 right-0 bottom-0 bg-black bg-opacity-50 ${overlayClassName}`}
      style={style}
    >
      {children}
    </BaseModal>
  );
};

const BaseModal = ({
  isOpen,
  onRequestClose,
  children,
  ariaHideApp = false,
  appElement = typeof window !== "undefined"
    ? document.getElementById("app") || undefined
    : undefined,
  shouldCloseOnOverlayClick = true,
  shouldCloseOnEsc = true,
  className,
  overlayClassName,
  style,
}: ModalProps) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  return (
    <ReactModal
      ariaHideApp={ariaHideApp}
      appElement={appElement}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      shouldCloseOnEsc={shouldCloseOnEsc}
      className={className}
      overlayClassName={overlayClassName}
      style={style}
    >
      {children}
    </ReactModal>
  );
};
